import React, { Component } from 'react';
import * as Gserv from '../services/GatewayService';
import { TimelineTwoTone, UndoTwoTone, PrintTwoTone, Settings} from '@material-ui/icons';
import {Paper, Grid, Typography, IconButton, Button, Tooltip} from '@material-ui/core';
import DatasheetView from './DatasheetView';
import ReactToPrint from 'react-to-print';
import moment from 'moment';
import XLSX from 'xlsx';
import ExcelLogo from '../assets/ExcelLogo';
import FilterBox from './FilterBox';
import Toggle from './Toggle';

export default class TalentMatrixReport extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            tm_avail: [],
            error: false,
            error_message: '',
            querying: true,
            show_report: false,
            current_record : {},
            tm_data : {},
            block : 'C3',
            filtered_assessments_array: [],
            filter_applied: false,
            filter_obj: {},
            show_all: false,
        };

        this.datasheetFieldSpecs = [
            // { field: 'id', headerName: 'Empl. #', width: 90, sortable:false},
            { field: 'report', headerName: 'Report', width: 80, headerAlign: 'center',
            sortable: false,
            renderCell: (parms) => (
                <IconButton 
                    onClick={()=>this.showReport(parms)} 
                    color='primary'
                >
                    <TimelineTwoTone/>
                </IconButton>
            )},
            { field: 'name', headerName: 'Assessee', width: 130},
            { field: 'assessee_id', headerName: 'Employee#', width: 130},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'store_code', headerName: 'Branch', width: 110, align:'center',headerAlign:'center'},
            { field: 'region', headerName: 'Region', width: 110, align:'center',headerAlign:'center'},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125},
            { field: 'cycle_code', headerName: 'Cycle Code', width: 130},
            { field: 'cycle_name', headerName: 'Cycle', width: 350, sortable:false},
        ]
    }

    componentDidMount = (show_all = false) => {
        //async request list of Talent Matrix reports available...
        if (this.state.tm_avail.length===0 || this.state.show_all!==show_all){  
            this.setState({querying:true, tm_avail:[], filtered_assessments_array:[]}); 
            Gserv.sendCommand('query_tm_avail',this.props.gwt,{show_all: show_all})
            .then(tm_avail => {
                // console.log('tm_avail :>> ', tm_avail);
                if (tm_avail.error){
                    console.log('error on return from Gserv (query_tm_avail) :>> ', tm_avail);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (tm_avail.Result!=="Success"&&tm_avail.statusCode!==204){
                    console.log('error on return from Gserv (query_tm_avail) :>> ', tm_avail);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    if (this.state.filter_applied){
                        this.setState({querying:false, tm_avail:tm_avail.Records?tm_avail.Records : []});
                        if (!tm_avail.Records) {this.setState({filtered_assessments_array:[]})}
                        this.applyFilter(this.state.filter_obj);
                    } else {
                        this.setState({querying:false, tm_avail:tm_avail.Records?tm_avail.Records : [], filtered_assessments_array:tm_avail.Records?tm_avail.Records : []});
                    }

                }
            }); 
        }
    };

    resetMe = () => {
        this.setState({error: false,error_message:'',show_report:false});
    }    

    showReport = (record) => {
        // console.log('record :>> ', record);
        this.setState({
            current_record:record.row,
            show_report:true,
            querying: true,
            tm_data: {},
            block: 'C3'
        });

        Gserv.sendCommand('query_tm_data',this.props.gwt,
        {
            assessee_id: record.row.assessee_id,
            cycle_id: record.row.cycle_id
        })
        .then(tm_data => {
            // console.log('tm_data :>> ', tm_data);
            if (tm_data.error){
                console.log('error on return from Gserv (tm_extract) :>> ', tm_data);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (tm_data.Result!=="Success"){
                console.log('error on return from Gserv (tm_extract) :>> ', tm_data);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                let perf_num = '3';
                let pm_symbol = 'C';
                const kpi = Number(tm_data.Record.KPI.key_datapoint_score_override? tm_data.Record.KPI.key_datapoint_score_override : tm_data.Record.KPI.key_datapoint_score);
                if (kpi>=90){perf_num = '2'}
                if (kpi>=100){perf_num = '1'}
                const pm = Number(tm_data.Record.PM.key_datapoint_score_override? tm_data.Record.PM.key_datapoint_score_override : tm_data.Record.PM.key_datapoint_score);
                if (pm === 2){
                    pm_symbol = 'B';
                } else if (pm === 3) {
                    pm_symbol = 'A';
                }
                this.setState({
                    tm_data: tm_data.Record,
                    block: pm_symbol + perf_num,
                    querying:false
                });
            }
        }); 

    }

    exportMe = () => {
        // console.log('called exportMe...');
        if (this.state.filtered_assessments_array.length>0){
            const dateStr = new moment().format("YYYY-MM-DD");
            var ws = XLSX.utils.json_to_sheet(this.state.filtered_assessments_array);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'TM Reports ' + dateStr);
            //Write to browser
            XLSX.writeFile(wb,'TMS Export - Available TM Reports as at ' + dateStr + '.xlsx');
        }
    }

    handleFilterChange = (filterObj) => {
        // console.log('filterObj :>> ', filterObj);
        if (filterObj.type==='clear'){
            this.setState({filtered_assessments_array : this.state.tm_avail, filter_obj: {}, filter_applied:false})
        } else {
            this.setState({filter_obj:filterObj});
            this.applyFilter(filterObj);
        }
    }

    applyFilter = (filterObj) => {
        if (this.state.tm_avail.length > 0){
            let temp_array = [];
            switch (filterObj.type) {
                case 'name':
                    for (const record of this.state.tm_avail){
                        if (record.name.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;

                case 'number':
                    for (const record of this.state.tm_avail){
                        if (record.assessee_id.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
 
                case 'rom':
                    for (const record of this.state.tm_avail){
                        if (record.reports_to_rom.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
            
                default:
                    break;
            }
            this.setState({filtered_assessments_array: temp_array, filter_applied:true});
        }
    }   

    handleToggleChange = (e) => {
        // console.log('e :>> ', e);
        // console.log("State show_all: ", this.state.show_all,' e.value: ',e.value);
        switch (e.field) {
            case 'show_all':
                if (e.value !== this.state.show_all){
                    this.setState({show_all:e.value});
                    this.componentDidMount(e.value);
                }
                break;

            default:
                break;
        }
    }

    render() {return(
        <Grid
            container
            direction='column'
            justifyContent='flex-start'
            alignContent='flex-start'
            // style={{backgroundColor:'yellow'}}
        >

            {!this.state.show_report&&
            <Grid item>
            <Paper
                elevation={3}
                style={{
                    // backgroundColor:'yellow',
                    width:1150
                }}
            >

                <Grid
                    container
                    // style={{backgroundColor:'yellow'}}
                    justifyContent='center'
                    alignContent='center'
                >

                    <Grid item xs={4}>
                        <div style={{display:'flex', justifyContent:'space-evenly', alignItems:"center"}}>
                            <Tooltip title="Export to Excel">
                            <span>
                            <IconButton 
                                aria-label='Export to Excel'
                                onClick={this.exportMe}
                                disabled={this.state.filtered_assessments_array.length===0}
                            >
                                <ExcelLogo />
                            </IconButton>
                            </span>
                            </Tooltip>
                        </div>
                    </Grid>

                    <Grid item xs={4}>
                        <Typography
                            color='primary'
                            style={{padding:10}}
                        >
                            Available Talent Matrix<br/>Reports
                        </Typography>
                    </Grid>

                    <Grid item xs={4}>
                        <Grid 
                            container
                            alignItems='center'
                            justifyContent='space-evenly'
                            // style={{backgroundColor:'yellow'}}
                        >
                            <FilterBox
                                setParentFilter={this.handleFilterChange}
                                data_populated={this.state.tm_avail.length>0? true : false}
                                filter_applied={this.state.filter_applied}
                                filter_obj={this.state.filter_obj}
                                show_hod_filter={true}
                                // show_branch_filter={true}
                                // show_cycle_filter={true}
                            />
                        </Grid>

                        <div style={{paddingLeft:'75px'}}>
                        <Toggle
                            fieldMap={{field: "show_all", headerName: "Include Closed Cycles?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true}} 
                            editRecord={{show_all: this.state.show_all}}
                            setField={this.handleToggleChange}
                        />
                        </div>

                    </Grid>

                </Grid>

                {/* Datagrid goes here */}
                <DatasheetView 
                    dataset={this.state.filtered_assessments_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={false}
                    edit={false}
                    handleDelete={null}
                    handleEdit={null}
                    loading={this.state.querying}
                    deleteHeaderName={'Delete'}
                    pagesize={15}
                    height={600}
                />
            </Paper>
            </Grid>}

            {this.state.show_report&&
            <Grid item>
            
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:825,
                        padding:15,
                    }}
                >
                    <Tooltip title="Back"><IconButton aria-label='Back' onClick={()=>this.setState({show_report:false, current_record:{}})}><UndoTwoTone /></IconButton></Tooltip>

                    <Tooltip title="Print or save as .pdf">
                        <span>
                        <ReactToPrint
                            content={() => this.componentRef}
                            bodyClass={'printSpecs'}
                            pageStyle={''}
                            trigger={() => <IconButton aria-label='Print or save as .pdf'><PrintTwoTone /></IconButton>}
                        />
                        </span>
                    </Tooltip>

                </Paper>

                <div id='Print Delimiter' 
                    ref={(response) => (this.componentRef = response)}
                >        

                <div
                    style={{borderWidth:'1px',borderStyle:'solid',padding:'10px'}}
                    
                >
                    <Typography color='primary' variant='h6'>Talent Matrix Report</Typography>
                    <Typography>For : <b>{this.state.current_record.name}</b> (Empl.# {this.state.current_record.assessee_id}) for cycle <b>{this.state.current_record.cycle_code}</b></Typography>
                    <Typography>{this.state.current_record.job_title} [<b>{this.state.current_record.store_code}</b>] Reporting to Manager: <b>{this.state.current_record.reports_to_rom}</b></Typography>
                    <Typography>Generated : {new Date().toDateString()}</Typography>
                </div>

                {this.state.querying&&
                <Typography
                    style={{marginTop:25}}
                >
                    <Settings className='icn-spinner' /><br/>
                    Extracting report data...
                </Typography>}

                {!this.state.querying&&
                <Grid item>
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'blue',
                        width:825,
                        padding:15
                    }}
                >
                <table>
                <tbody>
                    <tr>
                        <td colSpan={2} rowSpan={2}>
                            <Grid container direction='column' alignItems='center'>
                            <Grid 
                                container
                                direction='row'
                                justifyContent='center'
                                alignContent='center'
                            >
                                <Typography
                                    variant='h6'
                                >
                                    Classification:
                                </Typography>
                                &nbsp;
                                <Typography
                                    color="primary"
                                    variant='h6'
                                >
                                    {this.state.block}
                                </Typography>
                            </Grid>
                            <Grid 
                                container
                                direction='row'
                                justifyContent='center'
                                alignItems='center'
                                style={{
                                    borderWidth:1,
                                    borderStyle:'dashed',
                                    borderColor:'#bcbec0',
                                    width:'90%'
                                }}
                            >
                                <Typography>
                                    KPI Score:
                                </Typography>
                                &nbsp;
                                <Typography
                                    color="primary"
                                >
                                    {this.state.tm_data.KPI.key_datapoint_score_override? this.state.tm_data.KPI.key_datapoint_score_override : this.state.tm_data.KPI.key_datapoint_score}%
                                </Typography>
                                &nbsp;&nbsp;
                                <Typography>
                                    PM Rating:
                                </Typography>
                                &nbsp;
                                <Typography
                                    color="primary"
                                >
                                    {Number(this.state.tm_data.PM.key_datapoint_score_override? this.state.tm_data.PM.key_datapoint_score_override : this.state.tm_data.PM.key_datapoint_score)}
                                </Typography>
                            </Grid>
                            </Grid>
                        </td>
                        {/* <td></td> */}
                        <td colSpan={3}>
                            <Typography>&gt;&gt;&nbsp;&nbsp;POTENTIAL&nbsp;&nbsp;&gt;&gt;</Typography>
                            <hr/>
                        </td>
                    </tr>
                    <tr>
                        {/* <td>hello</td> */}
                        {/* <td>world</td> */}
                        <td>
                            <Typography style={{textAlign: 'center'}}>LOW POTENTIAL</Typography>
                        </td>
                        <td>
                            <Typography style={{textAlign: 'center'}}>STRONG</Typography>
                        </td>
                        <td>
                            <Typography style={{textAlign: 'center'}}>HIGH POTENTIAL</Typography>
                        </td>
                    </tr>
                    <tr>
                        <td rowSpan={3}
                            style={{borderRight: '2px #bcbec0', borderRightStyle:'inset'}}
                        >
                            <Typography
                                className='verticalText'
                            >
                                &gt;&gt;&nbsp;&nbsp;PERFORMANCE&nbsp;&nbsp;&gt;&gt;
                            </Typography>
                        </td>
                        <td style={{paddingLeft:10}}>
                            <Typography
                                // className='verticalText'                            
                            >
                                EXCEPTIONAL / ABOVE TARGET / ROLE MODEL
                            </Typography>
                        </td>
                        <td style={{backgroundColor: this.state.block==='C1'? 'yellow': 'white',border: this.state.block==='C1'? '4px outset #006e7a' : '1px dashed #bcbec0'}}>
                            <Typography
                                style={{padding:5}}
                            >
                                <b>C1</b>
                                <br/> 
                                HIGH PERFORMANCE / LOW POTENTIAL
                            </Typography>
                        </td>
                        <td style={{backgroundColor:this.state.block==='B1'?'green':'white',border: this.state.block==='B1'? '4px outset #006e7a' : '1px dashed #bcbec0'}}>
                            <Typography
                                style={{padding:5, color: this.state.block==='B1'? 'whitesmoke' : ''}}
                                
                            >
                                <b>B1</b>
                                <br/>
                                HIGH PERFORMANCE &amp; STRONG POTENTIAL
                            </Typography>    
                        </td>
                        <td style={{backgroundColor:this.state.block==='A1'? 'green' : 'white',border: this.state.block==='A1'? '4px outset #006e7a' : '1px dashed #bcbec0'}}>
                            <Typography
                                style={{padding:5, color: this.state.block==='A1'? 'whitesmoke' : ''}}
                            >
                                <b>A1</b>
                                <br/>
                                HIGH PERFORMANCE &amp; HIGH POTENTIAL
                            </Typography>
                        </td>
                    </tr>
                    <tr>
                        <td style={{paddingLeft:10}}>
                            <Typography
                                // className='verticalText'                            
                            >
                                SOLID / ON TARGET
                            </Typography>        
                        </td>
                        <td style={{backgroundColor:this.state.block==='C2'? 'red' : 'white',border: this.state.block==='C2'? '4px outset #006e7a' : '1px dashed #bcbec0'}}>
                            <Typography
                                style={{padding:5, color: this.state.block==='C2'? 'wheat' : ''}}
                            >
                                <b>C2</b>
                                <br/>
                                SOLID PERFORMANCE / LOW POTENTIAL
                            </Typography>
                        </td>
                        <td style={{backgroundColor: this.state.block==='B2'? 'yellow' : 'white',border: this.state.block==='B2'? '4px outset #006e7a' : '1px dashed #bcbec0'}}>
                            <Typography
                                style={{padding:5}}
                            >
                                <b>B2</b>
                                <br/>
                                SOLID PERFORMANCE &amp; STRONG POTENTIAL
                            </Typography>
                        </td>
                        <td style={{backgroundColor: this.state.block==='A2'? 'green' : 'white',border: this.state.block==='A2'? '4px outset #006e7a' : '1px dashed #bcbec0'}}>
                            <Typography
                                style={{padding:5, color: this.state.block==='A2'? 'whitesmoke' : ''}}
                            >
                                <b>A2</b>
                                <br/>
                                SOLID PERFORMANCE &amp; HIGH POTENTIAL
                            </Typography>
                        </td>
                    </tr>
                    <tr>
                        <td style={{paddingLeft:10}}>
                            <Typography
                                // className='verticalText'                            
                            >
                                DEVELOPMENT NEEDED / BELOW TARGET / BELOW EXPECTATIONS
                            </Typography>
                        </td>
                        <td style={{backgroundColor: this.state.block==='C3'? 'red' : 'white',border: this.state.block==='C3'? '4px outset #006e7a' : '1px dashed #bcbec0'}}>
                            <Typography
                                style={{padding:5, color: this.state.block==='C3'? 'wheat' : ''}}
                            >
                                <b>C3</b>
                                <br/>
                                LOW PERFORMANCE &amp; LOW POTENTIAL
                            </Typography>
                        </td>
                        <td style={{backgroundColor: this.state.block==='B3'? 'red' : 'white',border: this.state.block==='B3'? '4px outset #006e7a' : '1px dashed #bcbec0'}}>
                            <Typography
                                style={{padding:5, color: this.state.block==='B3'? 'wheat' : ''}}
                            >
                                <b>B3</b>
                                <br/>
                                LOW PERFORMANCE &amp; STRONG POTENTIAL
                            </Typography>
                        </td>
                        <td style={{backgroundColor: this.state.block==='A3'? 'yellow' : 'white',border: this.state.block==='A3'? '4px outset #006e7a' : '1px dashed #bcbec0'}}>
                            <Typography
                                style={{padding:5}}
                            >
                                <b>A3</b>
                                <br/>
                                LOW PERFORMANCE &amp; HIGH POTENTIAL
                            </Typography>
                        </td>
                    </tr>
                </tbody>
            </table>
            </Paper>
            </Grid>}

            </div> 

            </Grid>}

            <Grid item>
                <Typography color='secondary' style={{Width:1150,maxWidth:1150, textAlign:'center'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
            </Grid>

        </Grid>
    )}
}